<template>
  <div>
    <div
      id="dropdown"
      v-if="isDropdownVisible"
      class="absolute right-0 z-50 w-4/6 bg-white rounded-lg shadow top-16"
    >
      <div class="flex items-center justify-between w-full p-2 px-3">
        <div>
          <h5 class="mt-2 text-base font-light text-gray-500">Filter</h5>
        </div>
        <div>
          <span class="cursor-pointer" @click="handleClose" >
            <i class="text-gray-500 fa-solid fa-xmark" />
          </span>
        </div>
      </div>

      <div class="w-full mt-2 mb-3">
        <label class="mx-3 mb-2">Status</label>
        <div class="mx-3 mb-2">
          <InputDropdown
            v-model="status"
            :options="statusOptions"
            defaultText="All Status"
          />
        </div>
      </div>

      <div class="flex justify-start gap-3 px-3 mt-3 mb-3">
        <Button
          @click="applyFilter"
          color="primary"
          size="base"
          class="px-6 py-2"
        >
          Filter
        </Button>

        <Button
          @click="resetFilter"
          color="alternative"
          variant="outlined"
          size="base"
          class="px-6 py-2"
        >
          Reset
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
  import InputDropdown from '@/components/ui/InputDropdown.vue'
  import Button from '@/components/ui/Button.vue'

  export default {
    name: 'VendorFilter',

    components: {
      InputDropdown,
      Button
    },

    data() {
      return {
        status: null,
        statusOptions: [
          { value: null, text: 'All Status' },
          { value: 'active', text: 'Active' },
          { value: 'inactive', text: 'Inactive' },
        ]
      }
    },

    props: {
      isDropdownVisible: {
        type: Boolean,
        required: true
      },
      initialFilters: {
        type: Object,
        default: () => ({
          status: null
        })
      }
    },

    watch: {
      isDropdownVisible(newValue) {
        if (newValue) {
          this.addOutsideClickListener()
        } else {
          this.removeOutsideClickListener()
        }
      },
      initialFilters: {
        handler(newFilters) {
          this.status = newFilters.status;
        },
        deep: true,
        immediate: true
      }
    },

    methods: {
      handleOutsideClick(event) {
        if (!this.$el.contains(event.target)) {
          this.$emit('update:isDropdownVisible', false);
        }
      },

      addOutsideClickListener() {
        setTimeout(() => {
          document.addEventListener('click', this.handleOutsideClick);
        }, 0);
      },

      removeOutsideClickListener() {
        document.removeEventListener('click', this.handleOutsideClick);
      },

      handleClose() {
        this.$emit('update:isDropdownVisible', false);
      },

      applyFilter() {
        const payload = {}
        if (this.status !== null && this.status !== false) {
          payload.status = this.status;
        }
        this.$emit('input', payload);
        this.$emit('reloadPage');

        this.handleClose();
      },

      resetFilter() {
        this.status = null;
        this.$emit('reset');
        this.handleClose();
      },

    }
  }
</script>
